export enum AuthEndpoints {
    LOGIN = '/authentication',
    UPDATE_PASSWORD = '/authentication/secret',
}
